var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonResearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2579.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Research",
    transform: "translate(1206.000000, 2579.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.946,27 L8.946,25.197 C8.946,20.337 11.119,15.976 14.538,13.023 L14.5,12.903 L12.946,7.996 C7.538,11.8 4,18.083 4,25.197 L4,32 L8,32 L8.946,32 L20,32 C22.761,32 25,29.762 25,27 L8.946,27 Z M20.629,2.445 C20.41,1.753 19.997,1.177 19.468,0.758 C18.858,0.274 18.093,0 17.297,0 C16.946,0 16.589,0.053 16.236,0.165 C16.005,0.238 15.787,0.333 15.584,0.446 C14.77,0.899 14.187,1.649 13.933,2.511 C13.87,2.727 13.826,2.949 13.805,3.175 C13.763,3.628 13.809,4.097 13.955,4.558 L13.969,4.603 L16.407,12.299 L17.427,15.521 L24.1,13.408 L23.08,10.186 L20.643,2.489 L20.629,2.445 Z M16,25 L29,25 L29,23 L16,23 L16,25 Z",
    id: 190
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonResearch);
export default __webpack_public_path__ + "static/media/common-research.0796f5fd.svg";
export { ForwardRef as ReactComponent };